import { HttpErrorResponse } from "@angular/common/http";
import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute, Router } from "@angular/router";
import { catchError, EMPTY } from "rxjs";

import { JobApplication } from "../../../api/models/job-application";
import { JobPostingService } from "../../../api/services/job-posting.service";

@Component({
  selector: "app-company-application",
  templateUrl: "./company-application.component.html",
  styleUrls: ["./company-application.component.scss"],
  standalone: false,
})
export class CompanyApplicationComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly jobPostingService = inject(JobPostingService);

  application: JobApplication = {};

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        const jobPostingId = params["jobPostingId"] ?? null;
        const applicationId = params["applicationId"] ?? null;

        if (jobPostingId && applicationId) {
          this.loadApplication(jobPostingId, applicationId);
        }
      });
  }

  private loadApplication(jobPostingId: string, applicationId: string): void {
    this.jobPostingService
      .getJobApplication({ jobPostingId, id: applicationId })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            this.router.navigate(["/errors/404"]);
          }
          return EMPTY;
        })
      )
      .subscribe((result) => {
        this.application = result;
      });
  }
}
